import createAction from 'redux-actions/es/createAction';

export const toggleModal = createAction('TOGGLE_MODAL');

export const openModal = createAction('OPEN_MODAL');

export const closeModal = createAction('CLOSE_MODAL');
